<script setup lang="ts">
import { snakeCaseToHumanLike } from "core/helpers";

const props = defineProps({
	replaceParams: {
		type: Boolean,
		default: true
	},
	ignorePaths: {
		type: Array,
		default () {
			return [];
		}
	},
	renamedPaths: {
		type: Object,
		default () {
			return ({});
		}
	}
});

const route = useRoute();
const { t } = useI18n();

const breadcrumbsEntries = computed<[string, string][]>(() => {
	const paths = route.path.slice(1)
		.split("/");

	const preparedPaths = paths.reduce<[string, string][]>((accumulator, pageName, index) => {
		const previousEntry = accumulator[index - 1];
		const pageNameAdapted = props.replaceParams ? paramValueToKey(pageName) : pageName;
		const pageNameRenamed = pageNameAdapted in props.renamedPaths ? props.renamedPaths[pageNameAdapted] : snakeCaseToHumanLike(pageNameAdapted);
		const pageNameAdaptedAndFiltered = props.ignorePaths.includes(pageNameAdapted) ? "" : pageNameRenamed;
		const link = previousEntry ? `${previousEntry[1]}/${pageName}` : `/${pageName}`;

		accumulator.push([pageNameAdaptedAndFiltered, link]);

		return accumulator;
	}, []);
	preparedPaths.unshift([t("home"), "/"]);

	return preparedPaths;
});

const paramValueToKey = (paramValue: string) => {
	const param = Object.entries(route.params).find(([, value]) => value === paramValue);

	return param ? param[0] : paramValue;
};
</script>

<template>
	<div class="flex gap-x-4">
		<ul class="flex">
			<li
				v-for="([pageName, link], i) in breadcrumbsEntries"
				:key="i"
				class="flex items-center uppercase font-medium text-sm"
			>
				<template v-if="pageName">
					<NuxtLink
						class="underline-offset-8 hover:underline"
						exact-active-class="font-bold"
						:to="link"
					>
						{{ pageName }}
					</NuxtLink>
					<span v-if="i !== breadcrumbsEntries.length - 1" class="select-none">&nbsp;/&nbsp;</span>
				</template>
			</li>
		</ul>
	</div>
</template>
